import React from 'react';
import {Button, Fab, Snackbar,} from '@mui/material';
import InfoOpenIcon from '@mui/icons-material/OpenInBrowser';
import InfoCloseIcon from '@mui/icons-material/CancelPresentation';

export default function Info({
  showInfo,
  setShowInfo,
  showStopButton,
  targetName,
  targetDistance,
}) {

  const stopButton = (
    <Button variant="contained" size="small" onClick={() => window.spacecast.controls.stopTravel()}>
      Stop Animation
    </Button>
  );

  const message = `You're viewing ${targetName.split('|').pop()} from ${targetDistance}`;

  return (
    <div style={{margin:"1rem"}}>
      <Fab onClick={() => setShowInfo(!showInfo)} style={{zIndex:1}}>
        {showInfo ? <InfoCloseIcon /> : <InfoOpenIcon />}
      </Fab>
      <Snackbar
        open={showInfo}
        message={message}
        action={showStopButton ? stopButton : null}
      />
    </div>
  );
}